import { getRequiredStringEnv } from 'utils/safeEnvParsing';

export const AUTH_WEB_URL = `${getRequiredStringEnv('NEXT_PUBLIC_SAME_DOMAIN_ONBOARDING_URL')}/auth/web/`;
